import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5eae6ea5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data" }
const _hoisted_2 = { class: "ws_mb20" }

import { onMounted, ref, watch, computed } from 'vue'
import { transformLogContent } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'log-info',
  props: ['visible', 'rowData', 'formatterMap'],
  emits: ['update:visible'],
  setup(__props, { emit: __emit }) {

const $emit = __emit
const props = __props
const list = ref([
  {
    label: '日志类型',
    value: '',
    key: 'logType',
  },
  {
    label: '日志ID',
    value: '',
    key: 'logId',
  },
])

const contentList: any = ref([])

const totalList = computed(() => {
  return list.value.concat(contentList.value)
})

const deviceName = ref('')

const cancel = () => {
  $emit('update:visible', false)
  deviceName.value = ''
}

watch(
  props,
  () => {
    if (props.visible) {
      updateRowData()
    }
  },
  {
    deep: true,
  }
)

const updateRowData = () => {
  deviceName.value = props.rowData.deviceName

  const data = props.rowData
  list.value = list.value.map((item: any) => {
    return {
      ...item,
      value: data[item.key] || '-',
    }
  })

  toLogContent()
}

const toLogContent = () => {
  const attrList = props.rowData.attrList
  contentList.value = transformLogContent(attrList, props.formatterMap)
}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": props.visible,
    "before-close": cancel,
    class: "log-detail-modal",
    width: "670px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("p", { class: "title ws_mb20" }, _toDisplayString(deviceName.value), 513), [
          [_vShow, deviceName.value]
        ]),
        _createVNode(_component_el_row, {
          class: "info",
          gutter: 30
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalList.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                key: index,
                span: 12
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_2, _toDisplayString(item.label) + " : " + _toDisplayString(item.value), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})